import 'Styles/templates/collection.scss'
import '../snippets/quick-shop'
import $ from 'cash-dom'
import axios from 'axios'
import { findSubstrings, handleize } from '../utils'

$(() => {
  const renderArrows = (scrolledLeft) => {
    const $cont = $('.subcollection-container')
    const $list = $('.subcollection-list')

    if ($list[0]) {
      if (scrolledLeft) {
        $('.list-arrow-left').css('display', 'flex')
        $('.list-gradient-left').show()
      } else {
        $('.list-arrow-left').hide()
        $('.list-gradient-left').hide()
      }

      if ($list[0].scrollWidth > $cont[0].scrollWidth) {
        $('.list-arrow-right').css('display', 'flex')
        $('.list-gradient-right').show()
      } else {
        $('.list-arrow-right').hide()
        $('.list-gradient-right').hide()
      }
    }
  }

  $('.subcollection-list').on('scroll', (e) => {
    renderArrows($(e.currentTarget)[0].scrollLeft > 0)
  })

  renderArrows()

  window.addEventListener('resize', (e) => {
    renderArrows($(e.currentTarget)[0].scrollLeft > 0)
  })

  if ($('.list-arrow-left')) {
    $('.list-arrow-left').on('click', () => {
      const el = $('.subcollection-list')[0]
      const scrolled = el.scrollLeft
      el.scrollLeft = scrolled - 200
    })
  }
  if ($('.list-arrow-right')) {
    $('.list-arrow-right').on('click', () => {
      const el = $('.subcollection-list')[0]
      const scrolled = el.scrollLeft
      el.scrollLeft = scrolled + 200
    })
  }
})

// filters

const DEFAULT_FILTERS = [
  'Movement:Automatic',
  'Movement:Hand-Winding',
  'Movement:Quartz',
  'Case Size:≤ 36mm',
  'Case Size:37-40mm',
  'Case Size:41-44mm',
  'Case Size:≥ 45mm',
  'Style:Casual',
  'Style:Chronograph',
  'Style:Diver',
  'Style:Pilot/Field',
  'Material:Stainless Steel',
  'Material:PVD/DLC',
  'Material:Other',
  'Gender:All Gender',
  'Gender:Mens',
]

const DEFAULT_PRICE_FILTERS = [
  'Price:< $250',
  'Price:$250-$500',
  'Price:$500-$1000',
  'Price:$1000-$2000',
  'Price:$2000-$5000',
  'Price:> $5000',
]

const ISO_STORES = [
  'en-gb',
  'en-ca',
  'en-au',
  'en-de',
  'en-sg',
  'en-int',
  'en-in',
  'en-ch',
]

class FiltersBase extends HTMLElement {
  getQueryParams() {
    return new Proxy(new URLSearchParams(window.location.search), {
      get: (searchParams, prop) => searchParams.get(prop),
    })
  }

  syncSelectedFilters() {
    const params = this.getQueryParams()
    if (params.filters) {
      const filters = params.filters.split(',')
      this.selectedFilters = filters.map((filter) => filter.replace('_', ':'))
    } else {
      this.selectedFilters = []
    }
  }

  watchQueryParamChangeEvent() {
    window.addEventListener(
      'popstate',
      this.onQueryParamChange ? this.onQueryParamChange.bind(this) : () => {}
    )
  }

  shouldHideProduct(product, filters) {
    const categories = filters.reduce((acc, filter) => {
      const preffix = filter.split(':')[0]
      if (acc.includes(preffix)) return acc
      if (preffix === 'Price') return acc
      return [...acc, preffix]
    }, [])

    // tag filters
    const shouldHide = categories.reduce((acc, category) => {
      const categoryFilters = filters.filter(
        (f) => f.split(':')[0] === category
      )

      if (category === 'Price') {
        return acc
      }

      return acc || !product.tags.some((tag) => categoryFilters.includes(tag))
    }, false)

    // price filters
    const priceFilters = filters.filter((f) => f.split(':')[0] === 'Price')
    if (priceFilters.length) {
      return (
        shouldHide ||
        !priceFilters.some((priceFilter) => {
          let calcFilter =
            priceFilter.includes('-') && priceFilter.split(':')[1]

          if (!calcFilter) {
            calcFilter =
              priceFilter.includes('<') && `$0-${priceFilter.split('< ')[1]}`
          }

          if (!calcFilter) {
            calcFilter =
              priceFilter.includes('>') &&
              `${priceFilter.split('> ')[1]}-$${Number.MAX_SAFE_INTEGER}`
          }

          if (!calcFilter) return true

          const bounds = calcFilter.split('-')
          const lowerBound = +bounds[0].split('$')[1] * 100
          const upperBound = +bounds[1].split('$')[1] * 100
          const isProductInRange =
            product.price >= lowerBound && product.price <= upperBound

          return isProductInRange
        }, shouldHide)
      )
    }

    return shouldHide
  }
}

class CollectionFilters extends FiltersBase {
  connectedCallback() {
    this.useDefaultFilters = this.dataset.useDefaultFilters === 'true'
    this.filterContainer = this.querySelector('#filterContainer')

    this.syncFilterData()
    this.syncSelectedFilters()
    this.renderFilters()
    this.watchQueryParamChangeEvent()

    if (!this.classList.contains('mbl')) {
      document.addEventListener('scroll', () => {
        const scrollPos = window.scrollY
        const collectionGridEl = document.querySelector(
          'collection-filtered-products'
        )

        const filterHeight = 0.8 * window.innerHeight // 80% of the screen height. this is defined in CSS
        const collectionGridScrollPos = collectionGridEl.offsetTop
        const collectionGridHeight = collectionGridEl.clientHeight

        const relativeThreshold =
          collectionGridScrollPos + collectionGridHeight - filterHeight

        this.style.width = this.parentElement.offsetWidth + 'px'

        if (scrollPos > relativeThreshold) {
          this.style.position = 'relative'
          this.style.bottom = '0px'
          this.style.top = null
          this.parentElement.style.display = 'flex'
          this.parentElement.style.alignItems = 'flex-end'
        } else if (scrollPos > 320) {
          this.style.position = 'fixed'
          this.style.top = '130px'
        } else {
          this.style.position = 'relative'
          this.style.top = '0px'
          this.style.bottom = null
          this.parentElement.style.display = 'flex'
          this.parentElement.style.alignItems = 'flex-start'
        }
      })
    }
  }

  syncFilterData() {
    const filterDataObjectStr = this.querySelector('[data-id="filter-data"]')
    this.products = []
    const filterData = JSON.parse(filterDataObjectStr.innerHTML)
    let filters =
      typeof filterData.filters === 'string'
        ? JSON.parse(filterData.filters)
        : filterData.filters

    if (!filters) {
      this.filterData = {
        filters: DEFAULT_FILTERS,
      }
    } else {
      const defaultPricingIndex = filters.findIndex(
        (filter) => filter.toLowerCase() === 'price:default'
      )

      if (defaultPricingIndex > -1) {
        filters = [
          ...filters.slice(0, defaultPricingIndex),
          ...DEFAULT_PRICE_FILTERS,
          ...filters.slice(defaultPricingIndex + 1),
        ]
      }

      this.filterData = {
        filters,
      }
    }
  }

  onQueryParamChange() {
    this.syncSelectedFilters()
    this.renderFilters()
    this.renderCheckedFilters()
  }

  onProductsFetch(products) {
    this.products = products
    this.syncSelectedFilters()
    this.renderFilters()
  }

  renderFilters() {
    this.renderFilterTagsForMobile()

    this.filterContainer.innerHTML = ''
    const filterGroups = this.filterData.filters.reduce((acc, filter) => {
      const [preffix, suffix] = filter.split(':')

      return { ...acc, [preffix]: [...(acc[preffix] || []), suffix] }
    }, {})

    const filterGroupEntries = Object.entries(filterGroups)

    for (const entry in filterGroupEntries) {
      const [key, filterItems] = filterGroupEntries[entry]
      switch (key) {
        case 'Brand':
          this.filterContainer.appendChild(
            this.useDefaultFilters
              ? this.getBrandFilterElementWithCollapser(key, filterItems)
              : this.getBrandFilterElement(key, filterItems)
          )
          break
        default:
          this.filterContainer.appendChild(
            this.getFilterElement(key, filterItems)
          )
      }
    }

    this.renderCheckedFilters()
  }

  renderFilterTagsForMobile() {
    const filterTagsContainer = this.querySelector(
      '#productGridInfoContainerMobile .filter-tags'
    )

    if (!filterTagsContainer) return

    filterTagsContainer.innerHTML = ''
    filterTagsContainer.classList.add('flex', 'flex-wrap', 'gap-2')

    if (!this.selectedFilters.length) {
      this.querySelector(
        '#productGridInfoContainerMobile .filter-tags-container'
      ).classList.add('hidden')
    } else {
      this.querySelector(
        '#productGridInfoContainerMobile .filter-tags-container'
      ).classList.remove('hidden')
    }

    Array.from(this.selectedFilters).forEach((filter) => {
      const filterTag = document.createElement('button')

      filterTag.classList.add(
        'px-2',
        'py-[6px]',
        'bg-white',
        'border-[1px]',
        'max-w-[300px]',
        'text-[12px]',
        'flex',
        'gap-4',
        'items-center',
        'justify-between'
      )

      const closeButton = `<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L11 11" stroke="black" stroke-linecap="round"/><path d="M1 11L11 1" stroke="black" stroke-linecap="round"/></svg>`
      filterTag.innerHTML = `<span>${
        filter.split(':')[1]
      }</span><span>${closeButton}</span>`

      const mainCollectionProductGrid = document.querySelector(
        '#mainCollectionProductGrid'
      )

      filterTag.addEventListener('click', () => {
        mainCollectionProductGrid
          .querySelectorAll('collection-filters')
          .forEach((el) => {
            el.removeFilter(filter)
          })
      })

      filterTagsContainer.appendChild(filterTag)
    })

    const clearAllButton = document.createElement('button')
    clearAllButton.classList.add('underline', 'text-[12px]', 'ml-[12px]')
    clearAllButton.innerHTML = this.dataset.clearAll
    clearAllButton.addEventListener('click', () => {
      mainCollectionProductGrid
        .querySelectorAll('collection-filters')
        .forEach((el) => {
          el.clearFilters()
        })
    })

    filterTagsContainer.appendChild(clearAllButton)
  }

  getBrandFilterElement(key, filterItems) {
    const filterGroup = document.createElement('div')
    filterGroup.classList.add('brand-filter-group')

    const filterGroupList = document.createElement('div')
    filterGroupList.dataset.groupKey = key
    filterGroupList.classList.add('brand-filter-group-list')

    const allBrandsFilterItem = document.createElement('button')
    allBrandsFilterItem.classList.add('brand-filter-item')
    allBrandsFilterItem.innerHTML = `<span>${this.dataset.allBrands}</span><span>${
      this.products && this.products.length ? this.getPredictedQuantity() : ''
    }</span>`
    allBrandsFilterItem.dataset.filter = this.dataset.allBrands
    filterGroupList.appendChild(allBrandsFilterItem)
    allBrandsFilterItem.addEventListener('click', (e) => {
      this.selectFilter(this.dataset.allBrands)
    })

    let index = 0
    let count = 0

    for (const item in filterItems) {
      if (count === 10) {
        break
      }
      const predictedQuantity = this.getPredictedQuantity(
        `${key}:${filterItems[item]}`
      )
      if (!predictedQuantity) {
        continue
      }

      const filterItem = document.createElement('button')
      filterItem.classList.add('brand-filter-item')
      filterItem.innerHTML = `<span>${filterItems[item]}</span><span>${
        predictedQuantity || ''
      }</span>`
      filterItem.dataset.filter = `${key}:${filterItems[item]}`
      filterGroupList.appendChild(filterItem)
      filterItem.addEventListener('click', () => {
        this.selectFilter(`${key}:${filterItems[item]}`)
      })
      index = item
      count++
    }

    filterGroup.appendChild(filterGroupList)

    const otherFilterItems = filterItems.slice(+index + 1)

    if (otherFilterItems.length) {
      const isOthersGroupCollapsed = !otherFilterItems
        .map((item) => `${key}:${item}`)
        .some((filter) => this.selectedFilters.includes(filter))
      const otherFilterGroupList = this.getFilterGroupListElement(
        key,
        otherFilterItems,
        isOthersGroupCollapsed
      )

      const hasItemsToDisplay = Array.from(
        otherFilterGroupList.querySelectorAll('button')
      ).some((item) => item.style.display !== 'none')

      if (hasItemsToDisplay) {
        const seeMoreButton = document.createElement('button')
        seeMoreButton.classList.add('see-more-button')
        seeMoreButton.innerHTML = isOthersGroupCollapsed
          ? this.dataset.seeMoreBrands
          : this.dataset.close
        seeMoreButton.addEventListener('click', () => {
          otherFilterGroupList.classList.toggle('collapsed')
          seeMoreButton.innerHTML = otherFilterGroupList.classList.contains(
            'collapsed'
          )
            ? this.dataset.seeMoreBrands
            : this.dataset.close
        })
        filterGroup.appendChild(otherFilterGroupList)
        filterGroup.appendChild(seeMoreButton)
      }
    }

    return filterGroup
  }

  getBrandFilterElementWithCollapser(key, filterItems) {
    const filterGroup = document.createElement('div')
    filterGroup.classList.add('filter-group')

    const filterGroupTitle = this.getFilterGroupTitleElement(
      key,
      filterItems,
      true
    )
    filterGroupTitle.addEventListener('click', () => {
      const filterGroupList =
        filterGroupTitle.parentElement.querySelector('.filter-group-list')
      filterGroupList.classList.toggle('collapsed')
      filterGroupTitle.querySelector('.arrow').classList.toggle('collapsed')
    })

    const brandFilterElement = this.getBrandFilterElement(key, filterItems)
    const filterGroupList = document.createElement('div')
    filterGroupList.classList.add('filter-group-list')
    filterGroupList.appendChild(brandFilterElement)

    filterGroup.appendChild(filterGroupTitle)
    filterGroup.appendChild(filterGroupList)

    return filterGroup
  }

  getFilterGroupTitleElement(key, filterItems, isNotCollapsed) {
    const isGroupCollapsed = !filterItems
      .map((item) => `${key}:${item}`)
      .some((filter) => this.selectedFilters.includes(filter))

    const filterGroupTitle = document.createElement('button')
    filterGroupTitle.setAttribute('aria-label', this.dataset.filterGroupTitleAriaLabel)
    filterGroupTitle.classList.add('filter-group-title')
    let arrowClass = `arrow${isGroupCollapsed ? ' collapsed' : ''}`
    arrowClass = isNotCollapsed ? 'arrow' : arrowClass
    const facetArrowUrl =
      'https://cdn.shopify.com/s/files/1/0278/9723/3501/t/6/assets/icon-facet-arrow.svg'
    filterGroupTitle.innerHTML = `<span>${key}</span><span class="${arrowClass}"><img src="${facetArrowUrl}" aria-hidden="true"></span>`

    return filterGroupTitle
  }

  getFilterElement(key, filterItems) {
    const isGroupCollapsed = !filterItems
      .map((item) => `${key}:${item}`)
      .some((filter) => this.selectedFilters.includes(filter))
    const filterGroup = document.createElement('div')
    filterGroup.classList.add('filter-group')

    const filterGroupTitle = this.getFilterGroupTitleElement(key, filterItems)
    filterGroupTitle.addEventListener('click', () => {
      const filterGroupList =
        filterGroupTitle.parentElement.querySelector('.filter-group-list')
      filterGroupList.classList.toggle('collapsed')
      filterGroupTitle.querySelector('.arrow').classList.toggle('collapsed')
    })

    const filterGroupList = this.getFilterGroupListElement(
      key,
      filterItems,
      isGroupCollapsed
    )

    filterGroup.appendChild(filterGroupTitle)
    filterGroup.appendChild(filterGroupList)

    return filterGroup
  }

  getFilterGroupListElement(key, filterItems, isGroupCollapsed) {
    const filterGroupList = document.createElement('div')
    filterGroupList.dataset.groupKey = key
    filterGroupList.classList.add('filter-group-list')
    isGroupCollapsed && filterGroupList.classList.add('collapsed')

    for (const item in filterItems) {
      const predictedQuantity = this.getPredictedQuantity(
        `${key}:${filterItems[item]}`
      )
      const filterItem = document.createElement('button')
      filterItem.classList.add('filter-item')
      filterItem.innerHTML = `<div class="content"><span>${
        filterItems[item]
      }</span><span>${predictedQuantity || ''}</span></div>`
      filterItem.dataset.filter = `${key}:${filterItems[item]}`

      const shouldHideFilter = !predictedQuantity
      if (shouldHideFilter) {
        filterItem.style = 'display: none;'
      }
      filterGroupList.appendChild(filterItem)
      filterItem.addEventListener('click', () => {
        this.selectFilter(`${key}:${filterItems[item]}`)
      })
    }

    return filterGroupList
  }

  getPredictedQuantity(filter) {
    if (!this.products.length) return 0
    const predictedProducts = this.products.filter((product) => {
      if (product.isOutOfMarket) {
        return false
      }

      if (!filter) {
        const shouldHideProduct = this.shouldHideProduct(
          product,
          this.selectedFilters
        )
        return !shouldHideProduct
      } else {
        const filterPreffix = filter.split(':')[0]

        const predictedOptions = [
          ...this.selectedFilters.filter(
            (item) => item.split(':')[0] !== filterPreffix
          ),
          filter,
        ]
        const shouldHideProduct = this.shouldHideProduct(
          product,
          predictedOptions
        )
        return !shouldHideProduct
      }
    })

    return predictedProducts.length
  }

  selectFilter(filter) {
    if (filter === 'All Brands') {
      this.selectedFilters = this.selectedFilters.filter(
        (f) => !f.includes('Brand:')
      )
    } else {
      if (this.selectedFilters.includes(filter)) {
        this.selectedFilters = this.selectedFilters.filter((f) => f !== filter)
      } else {
        this.selectedFilters = [...this.selectedFilters, filter]
      }
    }

    this.renderFilters()
    this.renderCheckedFilters()
    this.setSearchParams()
    this.refreshPLPProducts()
  }

  removeFilter(filter) {
    this.selectedFilters = this.selectedFilters.filter((f) => f !== filter)

    this.renderFilters()
    this.renderCheckedFilters()
    this.setSearchParams()
    this.refreshPLPProducts()
  }

  clearFilters() {
    this.selectedFilters = []

    this.renderFilters()
    this.renderCheckedFilters()
    this.setSearchParams()
    this.refreshPLPProducts()
  }

  refreshPLPProducts() {
    const collectionFilteredProducts = document
      .querySelector('#mainCollectionProductGrid')
      .querySelector('collection-filtered-products')
    collectionFilteredProducts.refreshProducts()
  }

  setSearchParams() {
    if (this.selectedFilters.length === 0) {
      const url = new URL(window.location)
      url.searchParams.delete('filters')
      window.history.pushState({}, '', url)
      return
    }

    const url = new URL(window.location)
    url.searchParams.set(
      'filters',
      this.selectedFilters.map((f) => f.replace(':', '_')).join(',')
    )
    window.history.pushState({}, '', url)
  }

  renderCheckedFilters() {
    const filterItems = this.filterContainer.querySelectorAll('.filter-item')
    filterItems.forEach((item) => {
      this.selectedFilters.includes(item.dataset.filter)
        ? item.classList.add('checked')
        : item.classList.remove('checked')
    })

    const brandFilterItems =
      this.filterContainer.querySelectorAll('.brand-filter-item')
    brandFilterItems.forEach((item) => {
      if (item.dataset.filter === 'All Brands') {
        const hasBrandFilter = this.selectedFilters.some((f) =>
          f.includes('Brand:')
        )

        if (hasBrandFilter) {
          item.classList.remove('checked')
        } else {
          item.classList.add('checked')
        }

        return
      }

      this.selectedFilters.includes(item.dataset.filter)
        ? item.classList.add('checked')
        : item.classList.remove('checked')
    })
  }
}

customElements.define('collection-filters', CollectionFilters)

class MobileFacets extends HTMLElement {
  connectedCallback() {
    this.classList.add('hidden')
    this.querySelector('.filter-nav__done').addEventListener(
      'click',
      this.toggle.bind(this)
    )
  }

  toggle() {
    this.classList.toggle('hidden')

    if (this.classList.contains('hidden')) {
      document.body.style.overflow = 'visible'
    } else {
      document.body.style.overflow = 'hidden'
    }
  }
}

customElements.define('mobile-facets', MobileFacets)

class CollectionFilteredProducts extends FiltersBase {
  connectedCallback() {
    this.init()

    this.unobservedCount = 0

    this.fetchProducts().then((rawProducts) => {
      const rawCollectionData = this.querySelector(
        '[data-id="collection-data"]'
      )
      if (rawCollectionData) {
        const collectionData = JSON.parse(rawCollectionData.innerHTML)
        const products = this.mapProductsToTemplate(rawProducts)
        const productsToDisplay = collectionData.itemsToDisplayLimit
          ? products.slice(0, collectionData.itemsToDisplayLimit)
          : products

        this.addProductsToFilters(productsToDisplay)
        this.initProducts(productsToDisplay)
        this.initSort()
      }
    })
  }

  init() {
    this.filteredProducts = []
    this.excludedCountryIso = JSON.parse(
      this.querySelector('[data-id="excluded-country-iso"]').innerHTML
    )
  }

  initProducts(products) {
    this.products = products
    this.productListContainer = this.querySelector('#productListContainer')

    this.productsPerPage = 90
    this.page = 1

    this.syncSelectedFilters()
    this.renderProducts()
    this.watchQueryParamChangeEvent()
  }

  addProductsToFilters(products) {
    const mainCollectionProductGrid = document.querySelector(
      '#mainCollectionProductGrid'
    )

    Array.from(
      mainCollectionProductGrid.querySelectorAll('collection-filters')
    ).forEach((el) => {
      el.onProductsFetch(products)
    })
  }

  initSort() {
    const sortElement = this.querySelector('.sort')
    sortElement.classList.toggle('hidden')
    this.selectedSort = 'relevance'
    sortElement.querySelector('select').addEventListener('change', (ev) => {
      this.selectedSort = ev.target.value

      this.productsPerPage = 90
      this.page = 1

      this.syncSelectedFilters()
      this.renderProducts()
      this.watchQueryParamChangeEvent()
    })
  }

  isProductOutOfMarket(product) {
    const store = findSubstrings(ISO_STORES, window.location.href)[0]

    if (!store) return false
    
    const marketMap = {
      'en-gb': product.displayOutOfMarketGB?.value || false,
      'en-ca': product.displayOutOfMarketCA?.value || false,
      'en-au': product.displayOutOfMarketAU?.value || false,
      'en-de': product.displayOutOfMarketDE?.value || false,
      'en-sg': product.displayOutOfMarketSG?.value || false,
      'en-int': product.displayOutOfMarketINT?.value || false,
      'en-in': product.displayOutOfMarketIN?.value || false,
      'en-ch': product.displayOutOfMarketCH?.value || false,
    }
    
    const showOutOfMarket = marketMap[store] ? marketMap[store].value : false
    
    const handleizedVendor = handleize(product.vendor)
    const hideVendorForLocale = this.excludedCountryIso[handleizedVendor]?.split('|').includes(store)
    
    return !showOutOfMarket ? hideVendorForLocale : false
  }

  mapProductsToTemplate(products) {
    const store = findSubstrings(ISO_STORES, window.location.href)[0]

    return products.map((product) => {
      const rawFirstAvailableVariant = product.variants.edges.find(
        (variantNode) => variantNode.availableForSale
      )

      const firstAvailableVariant = rawFirstAvailableVariant
        ? rawFirstAvailableVariant.node
        : product.variants.edges[0].node

      const images = product.images.edges.map((edge) => edge.node.src)

      return {
        ...product,
        price: firstAvailableVariant.price.amount * 100,
        compare_at_price: firstAvailableVariant.compareAtPrice
          ? firstAvailableVariant.compareAtPrice.amount * 100
          : null,
        featured_image: product.featuredImage
          ? product.featuredImage.src
          : null,
        images,
        available: product.availableForSale,
        variants:
          product.variants && product.variants.edges
            ? product.variants.edges.map((edge) => edge.node)
            : [],
        isOutOfMarket: this.isProductOutOfMarket(product),
        productInquiryForm: product.productInquiryForm?.value,
        isComingSoon: product.productInquiryForm?.value?.toLowerCase() === this.dataset.comingSoon?.toLowerCase(),
        dontSuppress: product.dontSuppress?.value,
        isAlwaysSpecialInquiry:
          product.productInquiryForm?.value.toLowerCase() === this.dataset.contactToPurchaseAlways.toLowerCase(),
        isSpecialInquiry:
          product.productInquiryForm?.value.toLowerCase() ===
          this.dataset.contactToPurchaseWhileInStock.toLowerCase(),
        isAutomaticSpecialInquiry:
          product.productInquiryForm?.value.toLowerCase() ===
          this.dataset.contactToPurchaseWhenOutOfStock.toLowerCase(),
      }
    })
  }

  inViewObserver = (callback) => {
    const observer = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          const target = entry.target
          const productMedia = target.querySelector('.product-item-media')
          if (productMedia) {
            productMedia.classList.add('animated')
          }
          observer.unobserve(target)
          if (callback) callback()
        }
      }
    })
    return observer
  }

  throttle = (func, delay) => {
    let wait = false

    return (...args) => {
      if (wait) {
        return
      }

      func(...args)
      wait = true
      setTimeout(() => {
        wait = false
      }, delay)
    }
  }

  renderMoreProducts = this.throttle(() => {
    const target = this.productListContainer
    const index = this.productsPerPage * this.page
    const productsToDisplay = this.filteredProducts.slice(
      index,
      index + this.productsPerPage
    )

    for (const productIndex in productsToDisplay) {
      const product = productsToDisplay[productIndex]
      const productItem = this.getProductItem(product)

      if (this.productsPerPage - 1 === +productIndex + 15) {
        this.inViewObserver(this.renderMoreProducts).observe(productItem)
      } else {
        this.inViewObserver().observe(productItem)
      }

      target.appendChild(productItem)
    }

    this.page += 1
  }, 300)

  async fetchProducts() {
    try {
      const endpoint = `${this.dataset.productsApiUrl}/api/teddy/collection/${this.dataset.collectionId}/products`
      const res = await axios.get(endpoint, {
        id: `${this.dataset.collectionId}`,
      })

      return res.data.products
    } catch (e) {
      return this.onApiFetchProductsFailCallback()
    }
  }

  async onApiFetchProductsFailCallback() {
    const endpoint =
      'https://teddy-baldassarre-watches.myshopify.com/api/2025-01/graphql.json'
    const token = '0172fb0ba8e0fc0685f8dc8a458ff088'
    const headers = { 'X-Shopify-Storefront-Access-Token': token }
    const query = `
      query getCollectionById($id: ID!, $after: String) {
        collection(id: $id) {
          products(first: 250, after: $after) {
            edges {
              cursor
              node {
                id
                handle
                featuredImage {
                  altText
                  src
                }
                images(first: 10) {
                  edges {
                    node {
                      altText
                      src
                    }
                  }
                }
                comingSoon: metafield(namespace: "accentuate", key: "coming_soon") {
                  value
                }
                productInquiryForm: metafield(namespace: "custom", key: "product_inquiry") {
                  value
                }
                dontSuppress: metafield(namespace: "teddy", key: "dont_suppress_out_of_stock") {
                  value
                }
                tags
                title
                vendor
                availableForSale
                variants(first: 250) {
                  edges {
                    node {
                      availableForSale
                      id
                      price {
                        amount
                      }
                      compareAtPrice {
                        amount
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    `

    let products = []
    let cursor = null

    do {
      const { data } = await axios.post(
        endpoint,
        {
          query,
          variables: {
            id: `gid://shopify/Collection/${this.dataset.collectionId}`,
            after: cursor,
          },
        },
        { headers }
      )

      if (data.data.collection) {
        const rawProductsResponse = data.data.collection.products.edges
        const lastProduct = rawProductsResponse[rawProductsResponse.length - 1]
        const nextCursor = lastProduct ? lastProduct.cursor : null
        cursor = nextCursor

        products = [
          ...products,
          ...rawProductsResponse.map((edge) => edge.node),
        ]
      } else {
        cursor = null
      }
    } while (cursor)

    return products
  }

  refreshProducts() {
    this.syncSelectedFilters()
    this.renderProducts()
    const banner = document.querySelector('.collection__banner')

    if (banner)
      setTimeout(() => banner.scrollIntoView({ behavior: 'smooth' }), 150)
  }

  onQueryParamChange() {
    this.refreshProducts()
  }

  prioritizeProducts(products) {
    const sortedProducts = this.getSortedProducts(products)

    const bottomProducts = sortedProducts.filter((product) => {
      const { isOutOfMarket, available, dontSuppress, isComingSoon, isAlwaysSpecialInquiry, isSpecialInquiry } = product
      const isInquiry = isAlwaysSpecialInquiry || isSpecialInquiry

      return (isOutOfMarket && !isInquiry) || (!available && !dontSuppress && !isComingSoon && !isInquiry)
    })

    const secondaryProducts = sortedProducts.filter((product) => {
      const { isOutOfMarket, available, dontSuppress, isComingSoon, isAlwaysSpecialInquiry, isSpecialInquiry } = product
      const isInquiry = isAlwaysSpecialInquiry || isSpecialInquiry

      return (isOutOfMarket && isInquiry) || (!available && !dontSuppress && !isComingSoon && isInquiry)
    })

    const primaryProducts = sortedProducts.filter((product) => {
      const { isOutOfMarket, available, dontSuppress, isComingSoon, } = product
      return !isOutOfMarket && (available || dontSuppress || isComingSoon)
    })

    return [...primaryProducts, ...secondaryProducts, ...bottomProducts]
  }

  renderProducts() {
    if (!this.products && this.selectedFilters.length) return

    const target = this.productListContainer
    target.innerHTML = ''

    const rawCollectionData = this.querySelector('[data-id="collection-data"]')
    const collectionData = JSON.parse(rawCollectionData.innerHTML)
    const defaultProducts = collectionData.products

    const products = this.products || defaultProducts

    this.filteredProducts = products.filter((product) => {
      if (collectionData.hideOutOfMarket && product.isOutOfMarket) return false

      const shouldHideProduct = this.shouldHideProduct(
        product,
        this.selectedFilters
      )

      return !shouldHideProduct
    })

    this.filteredProducts = this.prioritizeProducts(this.filteredProducts) 

    const productsToDisplay = this.filteredProducts.slice(
      0,
      this.productsPerPage * this.page
    )

    if (this.products) {
      const filterTagsContainer = this.querySelector(
        '#productGridInfoContainer .filter-tags'
      )

      filterTagsContainer.innerHTML = ''
      filterTagsContainer.classList.add(
        'hidden',
        'md:flex',
        'flex-wrap',
        'gap-2'
      )

      if (!this.selectedFilters.length) {
        this.querySelector(
          '#productGridInfoContainer .filter-tags-container'
        ).classList.add('opacity-0')
      } else {
        this.querySelector(
          '#productGridInfoContainer .filter-tags-container'
        ).classList.remove('opacity-0')
      }

      Array.from(this.selectedFilters).forEach((filter) => {
        const filterTag = document.createElement('button')

        filterTag.classList.add(
          'px-2',
          'py-[4px]',
          'bg-white',
          'border-[1px]',
          'max-w-[300px]',
          'text-[12px]',
          'flex',
          'gap-4',
          'items-center',
          'justify-between',
          'leading-none',
          'min-h-[32px]'
        )

        const closeButton = `<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L11 11" stroke="black" stroke-linecap="round"/><path d="M1 11L11 1" stroke="black" stroke-linecap="round"/></svg>`
        filterTag.innerHTML = `<span style="top: -1px; position: relative;">${
          filter.split(':')[1]
        }</span><span>${closeButton}</span>`

        const mainCollectionProductGrid = document.querySelector(
          '#mainCollectionProductGrid'
        )

        filterTag.addEventListener('click', () => {
          mainCollectionProductGrid
            .querySelectorAll('collection-filters')
            .forEach((el) => {
              el.removeFilter(filter)
            })
        })

        filterTagsContainer.appendChild(filterTag)
      })

      const clearAllButton = document.createElement('button')
      clearAllButton.classList.add('underline', 'text-[12px]', 'ml-[12px]')
      clearAllButton.innerHTML = this.dataset.clearAll
      clearAllButton.addEventListener('click', () => {
        mainCollectionProductGrid
          .querySelectorAll('collection-filters')
          .forEach((el) => {
            el.clearFilters()
          })
      })

      filterTagsContainer.appendChild(clearAllButton)

      const quantityContainer = this.querySelector(
        '#productGridInfoContainer .quantity'
      )
      quantityContainer.innerHTML = `Showing <span id="products-shown">${this.filteredProducts.length}</span> products`
    }

    for (const productIndex in productsToDisplay) {
      const product = productsToDisplay[productIndex]
      const productItem = this.getProductItem(product)

      if (this.productsPerPage - 1 === +productIndex + 15) {
        setTimeout(() => {
          this.inViewObserver(this.renderMoreProducts).observe(productItem)
        }, 1000)
      } else {
        this.inViewObserver().observe(productItem)
      }
      target.appendChild(productItem)
    }
  }

  getSortedProducts(products) {
    return products.sort((a, b) => {
      if (this.selectedSort === 'relevance') return 0

      if (this.selectedSort === 'bestSelling') {
        if (a.bestSellingRank > b.bestSellingRank) return 1
        if (a.bestSellingRank < b.bestSellingRank) return -1
        return 0
      }

      if (this.selectedSort === 'date') {
        if (a.createdAtRank > b.createdAtRank) return -1
        if (a.createdAtRank < b.createdAtRank) return 1
        return 0
      }

      if (this.selectedSort === '-date') {
        if (a.createdAtRank > b.createdAtRank) return 1
        if (a.createdAtRank < b.createdAtRank) return -1
        return 0
      }

      if (this.selectedSort === 'title') {
        if (a.title < b.title) return -1
        if (a.title > b.title) return 1
        return 0
      }

      if (this.selectedSort === '-title') {
        if (a.title < b.title) return 1
        if (a.title > b.title) return -1
        return 0
      }

      const aPrice = a.price
      const bPrice = b.price

      if (this.selectedSort === 'price') {
        if (aPrice < bPrice) return -1
        if (aPrice > bPrice) return 1
        return 0
      }

      if (this.selectedSort === '-price') {
        if (aPrice < bPrice) return 1
        if (aPrice > bPrice) return -1
        return 0
      }

      return 0
    })
  }

  getProductItem(product) {
    const $product = document.createElement('div')
    $product.classList.add('text-left', 'group', 'product-item')

    const productAnchor = document.createElement('a')
    const store = findSubstrings(ISO_STORES, window.location.href)[0]
    productAnchor.href = store
      ? `${store}/products/${product.handle}`
      : `/products/${product.handle}`
    $product.appendChild(productAnchor)

    //Handle Product Media
    const productMediaOverlay = document.createElement('div')
    productMediaOverlay.classList.add('product-item-media-overlay')
    productAnchor.appendChild(productMediaOverlay)

    const mediaWrapper = document.createElement('div')
    mediaWrapper.classList.add('relative')
    productAnchor.appendChild(mediaWrapper)

    const productMediaImg = this.getProductItemMediaImg(product.featured_image)    
    mediaWrapper.appendChild(productMediaImg)
    
    const secondaryImg = product.images[1]
    if (secondaryImg) {
      productMediaImg.classList.add(
        'lg:group-hover:opacity-0',
        'transition-opacity',
        'ease-in',
        'duration-100'
      )

      const productSecondaryMediaImg = this.getProductItemMediaImg(
        secondaryImg,
        [
          'opacity-1',
          'transition-opacity',
          'bg-cover',
          'bg-center',
          'bg-grey-75',
          'bg-blend-multiply',
          'ease-in',
          'duration-100',
          'absolute',
          'w-full',
          'h-full',
          'top-0',
          'left-0',
        ]
      )

      mediaWrapper.prepend(productSecondaryMediaImg)
    }
    
    // Handle Product tags
    const productTag = this.buildProductTag(product)
    if (productTag) {
      mediaWrapper.append(productTag)
    }

    // Handle Product CTA
    const buttonWrapper = this.buildProductCta(product, store)
    mediaWrapper.appendChild(buttonWrapper)

    // Handle Product Details 
    const productContent = this.buildProductContent(product) 
    productAnchor.appendChild(productContent)

    return $product
  }

  getProductItemMediaImg = (url, classes) => {
    const el = document.createElement('div')
    const hasClasses = classes && classes.length
    const defaultClasses = [
      'w-full',
      'pb-[122%]',
      'relative',
      'bg-cover',
      'bg-center',
      'bg-grey-75',
      'bg-blend-multiply',
    ]

    el.setAttribute(
      'class',
      hasClasses ? classes.join(' ') : defaultClasses.join(' ')
    )

    el.style.backgroundRepeat = 'no-repeat, repeat'
    el.style.backgroundImage = `url(${url}), url(${this.dataset.greyImg})`

    return el
  }

  buildProductTag(product) {
    const featuredTagRaw = product.tags.find((tag) =>
      tag.toLowerCase().includes('featured')
    )

    let tagText = ''

    if (featuredTagRaw) {
      tagText = featuredTagRaw.split(':')[1]
    } else if (product.isOutOfMarket) {
      tagText = this.dataset.outOfStock
    } else if (product.isComingSoon) {
      tagText = this.dataset.comingSoon
    } else if (
      !product.available &&
      !product.isAlwaysSpecialInquiry &&
      !product.isAutomaticSpecialInquiry &&
      !product.isComingSoon
    ) {
      tagText = this.dataset.outOfStock
    }

    if (!tagText) return null

    const productTag = document.createElement('div')
    productTag.classList.add(
      'absolute',
      'right-5',
      'top-5',
      'caption',
      'px-2',
      'py-1',
      'lg:px-3',
      'lg:py-2',
      'border-[#D4D4D8]',
      'border-[1px]',
      'text-[15px]',
      'bg-white'
    )
    productTag.innerHTML = `<span>${tagText}</span>`
    return productTag
  }

  buildProductCta(product, store) { 
    const $productCtaText = this.setProductCtaText(product, store)
    const buttonWrapper = document.createElement('div')
    buttonWrapper.classList.add(
      'hidden',
      'lg:block',
      'w-full',
      'absolute',
      'm-auto',
      'left-0',
      'right-0',
      'transition',
      'ease-in-out',
      'opacity-0',
      'group-hover:opacity-100',
      'group-hover:translate-y-[-10px]'
    )
    buttonWrapper.style.width = 'calc(100% - 40px)'
    buttonWrapper.style.bottom = '10px'
    buttonWrapper.appendChild($productCtaText)

    return buttonWrapper
  }
  
  setProductCtaText(product, store) {
    const productHref = store
      ? `${store}/products/${product.handle}`
      : `/products/${product.handle}`

    const $productCTA = document.createElement('button')
    $productCTA.classList.add('button', 'button--primary', 'button--full-width')
    $productCTA.setAttribute('tabindex', '-1')
    $productCTA.dataset.handle = product.handle

    if (product.isOutOfMarket) {
      $productCTA.classList.add('button--disabled')
      $productCTA.innerText = this.dataset.unavailable
      $productCTA.setAttribute('disabled', 'disabled')
      return $productCTA
    }

    const productButtonComingSoon = () => {
      $productCTA.innerText = this.dataset.comingSoon
      $productCTA.addEventListener('click', () => {
        window.location.href = productHref
      })
    }

    const productButtonAddToCart = () => {
      if (product.available) {
        $productCTA.classList.add('quick-shop-trigger')

        if (product.variants.length > 1) {
          $productCTA.innerText = this.dataset.quickShop
        } else {
          $productCTA.dataset.onlyVariant = true
          $productCTA.innerText = this.dataset.addToCart
        }
      } else {
        $productCTA.innerText = this.dataset.outOfStock
        $productCTA.classList.add('button--disabled')
        $productCTA.setAttribute('disabled', 'disabled')
      }
    }

    const productButtonSpecialInquiry = () => {
      $productCTA.innerText = this.dataset.contactToPurchase
      $productCTA.addEventListener('click', () => {
        window.location.href = productHref
      })
    }

    switch (product.productInquiryForm?.toLowerCase()) {
      case this.dataset.comingSoon.toLowerCase():
        productButtonComingSoon()
        break
      case this.dataset.contactToPurchaseWhileInStock.toLowerCase():
        product.available
          ? productButtonSpecialInquiry()
          : productButtonAddToCart()
        break
      case this.dataset.contactToPurchaseAlways.toLowerCase():
        productButtonSpecialInquiry()
        break
      case this.dataset.contactToPurchaseWhenOutOfStock.toLowerCase():
        product.available
          ? productButtonAddToCart()
          : productButtonSpecialInquiry()
        break

      default:
        productButtonAddToCart()
        break
    }

    return $productCTA
  }

  buildProductContent(product) {
    const productContent = document.createElement('div')
    productContent.classList.add('mt-2', 'px-2', 'lg:mt-6', 'lg:px-5')

    const productContentTitle = document.createElement('h3')
    productContentTitle.classList.add('caption', 'mb-1', 'lg:mb-2')
    productContentTitle.innerText = product.vendor
    productContent.appendChild(productContentTitle)

    const productContentSubtitle = document.createElement('p')
    productContentSubtitle.classList.add('mb-4', 'text-gray-500', 'lg:mb-5')
    productContentSubtitle.innerText = product.title
    productContent.appendChild(productContentSubtitle)

    const productContentPrice = document.createElement('div')
    const productContentPriceSpan = document.createElement('span')
    productContentPriceSpan.classList.add('caption', 'caption--price')
    const price = new Intl.NumberFormat(undefined, {
      currency: 'USD',
      maximumFractionDigits: 0,
      minimumFractionDigits: 0,
    })
      .format(product.price / 100)
      .replace(/\./g, ',')
    productContentPriceSpan.innerText = `$${price}`
    productContentPrice.appendChild(productContentPriceSpan)

    productContent.appendChild(productContentPrice)

    if (product.compare_at_price) {
      const productContentPriceCompare = document.createElement('s')
      productContentPriceCompare.classList.add(
        'caption',
        'caption--price',
        'text-gray-500',
        'inline-block',
        'mr-2'
      )
      productContentPriceCompare.innerText = `$${(
        product.compare_at_price / 100
      ).toFixed()}`
      productContentPrice.prepend(productContentPriceCompare)
    }
    
    return productContent
  }
}

customElements.define(
  'collection-filtered-products',
  CollectionFilteredProducts
)
